module.exports = __webpack_public_path__ + "static/media/Abhiram.c01ddb6e.jpeg";